"use strict";

const IntersectElements = function () {
  const intersectElements = Array.prototype.slice.call(
    document.getElementsByClassName("intersect-elem")
  );
  for (const elem of intersectElements) {
    new IntersectElem(elem);
  }
};

class IntersectElem {
  constructor(node) {
    this.node = node;
    if (this.node.classList.toString().includes("standby")) {
      return;
    }

    this.node.classList.add("standby"); // 多重掛け防止措置
    this.io = new IntersectionObserver(this.onIntersect, { rootMargin: "-10% 0% -20% 0%" });
    this.io.observe(this.node);
  }
  onIntersect = changes => {
    if (changes[0].isIntersecting) {
      const delay = this.node.dataset.delay ? Number(this.node.dataset.delay) : 0;

      setTimeout(() => {
        this.node.classList.add("active");
        this.io?.unobserve(this.node);
        this.io = null;
      }, delay * 1000);
    }
  };
}

export default IntersectElements;
